<template>
  <div class="options-wrapper">
    <b-tabs
      content-class="tab-content-modern"
      v-model="selected_tab"
      nav-class="tabs-nav-modern"
    >
      <b-tab title="Detalle">
        <div>
          <showApartment
            :asset_id="asset_id"
            :key="asset_id"
            :features="features"
            :photos="photos"
            :images="images"
          />
        </div>
      </b-tab>
      <template v-if="showPayment">
        <b-tab
          title="Pagos"
          v-if="
            customerId == 59 ||
            customerId == 129 ||
            customerId == 114 ||
            customerId == 147
          "
        >
          <div>
            <paymentsToku :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>

        <b-tab title="Pagos" v-else-if="customerId == 121 || customerId == 146">
          <div>
            <paymentsBlank :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="Pagos" v-else-if="customerId == 138">
          <div>
            <paymentsOtrosPagos :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="Pagos" v-else-if="haveForpay">
          <div>
            <paymentsForpay :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="Pagos" v-else-if="haveFintoc()">
          <div>
            <paymentsFintoc :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
        <b-tab title="Pagos" v-else>
          <div>
            <payments :asset_id="asset_id" :key="asset_id" />
          </div>
        </b-tab>
      </template>
      <b-tab title="Documentos" v-if="showDocuments">
        <div>
          <documents :asset_id="asset_id" :key="asset_id" />
        </div>
      </b-tab>
      <b-tab title="Pagos Automáticos" v-if="checkPac">
        <PaymentOptions
          :asset_id="asset_id"
          :project_id="project_id"
          :key="asset_id"
        />
      </b-tab>
      <b-tab title="Pagos Automáticos" v-if="haveForpay">
        <PaymentForpayOptions
          :asset_id="asset_id"
          :project_id="project_id"
          :key="asset_id"
        />
      </b-tab>
      <b-tab title="Postventa" v-if="checkAftersale && haveAftersale">
        <div>
          <aftersale
            :asset-id="asset_id"
            :key="asset_id"
            :contract-id="apartment.contract_id"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import showApartment from "./ShowApartmentNew";
import payments from "./payments/Payments";
import aftersale from "./aftersale/Aftersale";
import paymentsToku from "./payments/PaymentsToku";
import paymentsFintoc from "./payments/PaymentsFintoc";
import paymentsForpay from "./payments/PaymentsForpay";
import PaymentsBlank from "./payments/PaymentsBlank";
import PaymentsOtrosPagos from "./payments/PaymentsOtrosPagos";
import documents from "./documents/Documents";
import PaymentOptions from "./paymentOptions";
import PaymentForpayOptions from "./paymentForpayOptions";

export default {
  name: "options",
  components: {
    showApartment,
    payments,
    aftersale,
    documents,
    paymentsToku,
    paymentsFintoc,
    paymentsForpay,
    PaymentOptions,
    PaymentsOtrosPagos,
    PaymentsBlank,
    PaymentForpayOptions,
  },
  props: {
    asset_id: { default: null },
    tab_index: { default: 0 },
    project_id: { default: null },
    photos: { default: [] },
    images: { default: [] },
    features: { default: [] },
  },
  mounted() {
    this.$store.commit("setCards");
    this.syncContractId();
  },
  data() {
    return {
      selected_tab: Number(this.tab_index) || 0,
    };
  },
  methods: {
    haveFintoc() {
      let fintoc = [
        7, 13, 82, 1, 2, 53, 68, 42, 97, 96, 103, 102, 113, 101, 121, 138, 137,
        143,
      ];
      return fintoc.includes(this.customerId) ? true : false;
    },
    syncContractId() {
      const contractId =
        this.apartment && this.apartment.contract_id != null
          ? this.apartment.contract_id
          : null;
      this.$store.commit("setContractId", contractId);
    },
  },
  watch: {
    asset_id: {
      handler: function () {
        // Al cambiar de bien, respetar el tab solicitado por el padre (Home -> Apartments)
        this.selected_tab = Number(this.tab_index) || 0;
        this.syncContractId();
      },
    },
    apartment: {
      handler: function () {
        this.syncContractId();
      },
      immediate: true,
    },
    tab_index: {
      handler: function (newVal) {
        // Mantener sincronizado el tab activo cuando el padre cambia tab_index
        this.selected_tab = Number(newVal) || 0;
      },
      immediate: true,
    },
  },
  computed: {
    domain() {
      return this.$store.getters.getCustomerDomain;
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : 0;
    },
    showPayment() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_payment
        : false;
    },
    haveForpay() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "Forpay"
          )
          ? true
          : false
        : false;
    },
    showDocuments() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_document
        : false;
    },
    project() {
      return this.apartment
        ? this.$store.getters.getProjectByMoby(this.apartment.project_id)
        : null;
    },
    address() {
      return this.project
        ? `${this.project.direccion.direccion}, ${this.project.direccion.comuna}`
        : "";
    },
    addressCountry() {
      return this.project
        ? `${this.project.direccion.ciudad} ${this.project.direccion.pais}`
        : "";
    },
    apartment() {
      return this.$store.getters.getApartmentById(parseInt(this.asset_id));
    },
    haveAftersale() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "PostVenta"
          )
          ? true
          : false
        : false;
    },
    checkAftersale() {
      if (this.apartment && this.$store.state.haveAftersale) {
        if (this.$store.state.haveAftersale.length > 0) {
          if (
            this.$store.state.haveAftersale.find(
              (elem) => elem.id == this.apartment.project_id
            )
          ) {
            return this.$store.state.haveAftersale
              .find((elem) => elem.id == this.apartment.project_id)
              .value.includes(this.apartment.asset_state)
              ? this.$store.state.haveAftersale.find(
                  (elem) => elem.id == this.apartment.project_id
                )
              : false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkPac() {
      if (this.$store.getters.getCustomerData) {
        let fintoc = this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Fintoc"
        )
          ? true
          : false;
        let oneclick = false;
        if (this.customerId == 25) {
          if (
            this.project_id == 3 ||
            this.project_id == 9 ||
            this.project_id == 10 ||
            this.project_id == 11
          ) {
            oneclick = this.$store.getters.getCustomerData.products.find(
              (product) => product.name == "Pago One Click"
            )
              ? true
              : false;
          } else {
            oneclick = false;
          }
        } else {
          oneclick = this.$store.getters.getCustomerData.products.find(
            (product) => product.name == "Pago One Click"
          )
            ? true
            : false;
        }
        return fintoc || oneclick ? true : false;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.options-wrapper {
  margin-top: 8px;
  animation: optionsFadeIn 0.3s ease;
}

@keyframes optionsFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modern Tabs Navigation */
.options-wrapper :deep(.tabs-nav-modern) {
  display: flex;
  gap: 4px;
  padding: 6px;
  background: #f3f4f6;
  border-radius: 12px;
  margin-bottom: 34px;
  border: none;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  animation: tabsSlideIn 0.4s ease 0.1s backwards;
}

@keyframes tabsSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.options-wrapper :deep(.tabs-nav-modern)::-webkit-scrollbar {
  display: none;
}

.options-wrapper :deep(.nav-item) {
  flex-shrink: 0;
}

.options-wrapper :deep(.nav-link) {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border: none !important;
  background: transparent !important;
  color: #6b7280 !important;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 10px !important;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-transform: none;
}

.options-wrapper :deep(.nav-link:hover) {
  background: rgba(255, 255, 255, 0.6) !important;
  color: #374151 !important;
}

.options-wrapper :deep(.nav-link.active) {
  background: white !important;
  color: #1f2937 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Tab Content */
.options-wrapper :deep(.tab-content-modern) {
  padding-top: 8px;
  min-height: 200px;
}

.options-wrapper :deep(.tab-pane) {
  animation: tabContentFadeIn 0.3s ease;
}

@keyframes tabContentFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .options-wrapper {
    margin-top: 4px;
  }

  .options-wrapper :deep(.tabs-nav-modern) {
    padding: 4px;
    gap: 3px;
    margin-bottom: 16px;
    border-radius: 10px;
  }

  .options-wrapper :deep(.nav-link) {
    padding: 10px 14px;
    font-size: 0.8rem;
    border-radius: 8px !important;
  }

  .options-wrapper :deep(.tab-content-modern) {
    padding-top: 4px;
    min-height: 150px;
  }
}

@media (max-width: 576px) {
  .options-wrapper :deep(.tabs-nav-modern) {
    padding: 3px;
    gap: 2px;
    margin-bottom: 12px;
    border-radius: 8px;
  }

  .options-wrapper :deep(.nav-link) {
    padding: 8px 12px;
    font-size: 0.75rem;
    border-radius: 6px !important;
  }
}

@media (max-width: 400px) {
  .options-wrapper :deep(.nav-link) {
    padding: 7px 8px;
    font-size: 0.7rem;
  }
}
</style>
